/**
 * LINE OAuth callback 導回頁（Lite Square）
 * 從 URL 讀取 token、suffix，儲存 token 後導向 /lite/shop/:suffix
 */

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setLiteJwtToken } from '../../api/liteAuthToken';

export function OAuthReturnPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'done' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const suffix = searchParams.get('suffix');
    const err = searchParams.get('error');

    if (err) {
      try {
        setMessage(decodeURIComponent(err));
      } catch {
        setMessage(err);
      }
      setStatus('error');
      return;
    }

    if (!token && !suffix) {
      setMessage('缺少登入結果參數，請重新從「建立 Square」操作');
      setStatus('error');
      return;
    }

    if (token) {
      try {
        setLiteJwtToken(token);
      } catch (_) {
        setMessage('無法儲存登入狀態');
        setStatus('error');
        return;
      }
    }

    if (suffix) {
      const target = `${window.location.origin}/lite/shop/${suffix}`;
      requestAnimationFrame(() => {
        window.location.replace(target);
      });
    } else if (token) {
      // 僅登入（mode=choice）：導向選擇頁
      const target = `${window.location.origin}/lite/square-choice`;
      requestAnimationFrame(() => {
        window.location.replace(target);
      });
    } else {
      setMessage('缺少登入結果，請重新操作');
      setStatus('error');
    }
  }, [searchParams]);

  const loadingOrDone = (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center p-4 bg-gradient-to-br from-slate-50 to-slate-100">
      <p className="text-slate-600">登入成功，正在導向...</p>
    </div>
  );

  if (status === 'loading' || status === 'done') {
    return loadingOrDone;
  }

  if (status === 'error') {
    return (
      <div className="min-h-[100dvh] flex flex-col items-center justify-center p-4 bg-gradient-to-br from-slate-50 to-slate-100">
        <p className="text-red-600 mb-4">{message}</p>
        <a href="/lite/new-square" className="text-indigo-600 underline">
          返回建立 Square
        </a>
      </div>
    );
  }

  return loadingOrDone;
}
